/**
 * Platform adapter type — reuses IElectronAPI from electron.d.ts.
 * The web adapter implements this same interface.
 */

export type IPlatformAdapter = Window['electron'];

declare const __BOCLAW_WEB_MODE__: boolean | undefined;

export function isWebMode(): boolean {
  try {
    return typeof __BOCLAW_WEB_MODE__ !== 'undefined' && __BOCLAW_WEB_MODE__ === true;
  } catch {
    return false;
  }
}
